import React, { Fragment } from 'react'
import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import cgdreamLogo from 'images/cgdream_icon_dark.svg'

/**
 * Server component that renders as html without mounting;
 * Represents a cgdream button with dropdown menu
 */

function CgdreamLogo() {
  return (
    <Fragment>
      <div
        className={classnames(
          'cgt-icon',
          'cgt-icon__icon',
          'cgt-icon--default',
          'cgt-icon--primary',
        )}
      >
        <img src={cgdreamLogo} alt="CGDream" className="navbar-icon" />
      </div>
      <span className="cgd-logo__text">AI Image Generator</span>
    </Fragment>
  )
}

export default CgdreamLogo
